import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import StudioDocsView from "lib/components/builders/communities/studioDocs/StudioDocsView";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../../../components/withAuthentication";

function LocationStudioDocsPageReady() {
  const { builderId, locationId } = useAppRouterParams();
  if (!builderId || !locationId) {
    return null;
  }
  return <LocationStudioDocsPage builderId={builderId} locationId={locationId} />;
}

function LocationStudioDocsPage({ builderId, locationId }: { builderId: string; locationId: string }) {
  return (
    <CommunityLayout currentPage="studio_docs">
      <StudioDocsView builderId={builderId} locationId={locationId} />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/studio-docs/")({
  component: withAuthentication(LocationStudioDocsPageReady, { features: ["estimationTasks"] }),
});
